export const affiliateEmailTemplates = {
  staging: {
    subject: "Partnership Opportunity: Its-Sold.com FSBO Platform - Home Staging Referrals",
    body: `Hello {CONTACT_NAME},

My name is Larry Scala, and I'm reaching out from Its-Sold.com™, Dallas-Fort Worth's fastest-growing For Sale By Owner (FSBO) platform.

**Why We're Contacting {COMPANY_NAME}:**

We've identified {COMPANY_NAME} as one of the premier home staging companies in DFW, and we'd like to establish a formal referral partnership.

**About Its-Sold.com:**
- Free FSBO listing platform serving the entire DFW metroplex
- Growing database of sellers preparing homes for market
- Average home value: $300K-$500K
- Sellers actively seeking professional staging services

**Partnership Opportunity:**

We're building a curated "Seller Resources" section featuring top DFW service providers. We'd like to:

1. Feature {COMPANY_NAME} prominently on our Seller Resources page
2. Send qualified referrals directly to you
3. Establish a referral fee structure (typically 10-20% of staging fees)
4. Track conversions and provide analytics

**What You Get:**
✓ Free exposure to motivated FSBO sellers
✓ Qualified leads actively preparing homes for sale
✓ No upfront costs - only pay for closed business
✓ Direct contact information for all referrals
✓ Monthly performance reports

**Next Steps:**

I'd love to schedule a brief 15-minute call to discuss:
- Your current referral fee structure
- How we can best present your services
- Tracking and payment processes
- Any specific service packages for FSBO sellers

Are you available this week for a quick conversation? I'm flexible with timing.

Best regards,

Larry Scala
Founder, Its-Sold.com™
{YOUR_PHONE}
{YOUR_EMAIL}
larry@larryscala.com

P.S. We're currently driving 500+ monthly visitors to our resources page, with growth projected at 20% month-over-month.`
  },

  photography: {
    subject: "Partnership Opportunity: Its-Sold.com - Real Estate Photography Referrals",
    body: `Hello {CONTACT_NAME},

I'm Larry Scala, founder of Its-Sold.com™, DFW's leading FSBO platform.

**Why {COMPANY_NAME}?**

Your photography work stands out in the DFW market, and we'd like to create a referral partnership to connect you with FSBO sellers who need professional listing photos.

**The Challenge We're Solving:**

FSBO sellers often struggle to find quality photographers who understand real estate marketing. They need:
- HDR photos that make homes shine
- Quick turnaround (listings go live fast)
- Affordable packages without agent markup
- Drone shots for curb appeal

**What We're Offering:**

1. **Featured placement** on our high-traffic Seller Resources page
2. **Direct referrals** with seller contact information
3. **Commission structure:** 15-20% of booking or flat referral fee
4. **Zero upfront cost** - you only pay for closed business

**Our Seller Profile:**
- Average home value: $300K-$500K
- Tech-savvy sellers (they found us online)
- Motivated to present homes professionally
- Budget-conscious but quality-focused

**Proposed Partnership:**

- List your packages and pricing on our platform
- We send leads directly to you via email/SMS
- You handle bookings and service delivery
- Monthly invoicing for referral fees

**Can We Schedule 15 Minutes This Week?**

I'd love to discuss:
- Your preferred referral structure
- Special FSBO seller packages (if any)
- Lead volume expectations
- How we track and report conversions

Looking forward to partnering with you!

Best,

Larry Scala
Founder, Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. 73% of our sellers said "professional photos" was their #1 need. We're sitting on a goldmine of leads for you.`
  },

  painting: {
    subject: "Referral Partnership: Its-Sold.com - Pre-Sale Painting Projects in DFW",
    body: `Hi {CONTACT_NAME},

Larry Scala here from Its-Sold.com™, the DFW FSBO platform.

**The Opportunity:**

We're connecting with top painting contractors to refer pre-sale painting projects from homeowners listing on our platform.

**Why This Makes Sense for {COMPANY_NAME}:**

FSBO sellers need painting work to maximize sale price, but they:
- Don't have agent referrals
- Need quick turnaround (listing timeline pressure)
- Want competitive pricing without agent markup
- Value quality work (their money on the line)

**What We're Proposing:**

✓ Feature {COMPANY_NAME} on our Seller Resources page
✓ Send pre-qualified leads (sellers ready to spend)
✓ Referral fee: $50-$100 per job (or 10% of project value)
✓ You control pricing and scheduling
✓ We handle lead gen, you handle painting

**Typical Projects:**
- Interior touch-ups before listing
- Exterior curb appeal refresh
- Whole-house pre-sale painting
- Budget range: $2,000-$8,000 per project

**No Risk to You:**
- Zero marketing costs
- No upfront fees
- Only pay when you close business
- Cancel anytime

**15-Minute Call This Week?**

Let's discuss:
- Your capacity for new projects
- Referral fee structure that works for you
- Lead volume we can drive
- Special "seller prep" packages (optional)

Available Thursday or Friday this week?

Best regards,

Larry Scala
Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. Fresh paint can increase sale price by 2-5%. Our sellers know this and have budget allocated.`
  },

  cleaning: {
    subject: "Partnership: Its-Sold.com - Move-Out & Pre-Sale Cleaning Referrals",
    body: `Hello {CONTACT_NAME},

I'm reaching out from Its-Sold.com™ regarding a cleaning services referral partnership.

**The Need:**

FSBO sellers listing with us consistently need move-out and pre-sale deep cleaning services. Currently, they're:
- Searching randomly on Google
- Getting inconsistent service
- Paying retail prices without agent discounts

**Why Partner with Us:**

We want to connect {COMPANY_NAME} with sellers who need:
- Deep cleaning before listing photos
- Move-out cleaning after vacating
- Monthly maintenance during listing period
- Show-ready cleaning between showings

**Partnership Details:**

1. **Featured Listing:** Prominent placement on our Seller Resources page
2. **Direct Referrals:** We send lead info directly to you
3. **Commission:** $40 per job or 15% of cleaning fee
4. **No Costs:** Only pay for actual bookings

**Our Seller Profile:**
- Homes valued $300K-$500K
- Need immediate service (active listings)
- Repeat business potential (weekly cleanings)
- Referral-friendly (tell other sellers)

**Typical Services Needed:**
- Pre-listing deep clean: $300-$500
- Move-out cleaning: $400-$600
- Weekly maintenance: $150-$250
- Post-showing touch-ups: $100-$150

**Next Steps:**

Can we schedule a brief call to discuss:
- Your referral program (if existing)
- Service packages for FSBO sellers
- Scheduling and availability
- Payment/invoicing process

Available this week for 15 minutes?

Thanks,

Larry Scala
Its-Sold.com™ Founder
{YOUR_PHONE}
larry@larryscala.com

P.S. We're projecting 50+ cleaning referrals per month by Q2 2025.`
  },

  handyman: {
    subject: "Referral Opportunity: Its-Sold.com - Pre-Sale Home Repairs in DFW",
    body: `Hi {CONTACT_NAME},

Larry Scala from Its-Sold.com™ here. Quick question: Are you interested in pre-sale home repair referrals?

**Here's the Situation:**

We run DFW's leading FSBO platform. Our sellers constantly need handyman work before listing:
- Drywall patches
- Door/trim repairs
- Fixture replacements
- Minor electrical fixes
- Painting touch-ups

Problem: They don't have agent referrals and end up with unlicensed workers.

**The Partnership:**

We'd like to send {COMPANY_NAME} qualified handyman leads in exchange for referral fees.

**What You Get:**
✓ Steady flow of repair projects
✓ Motivated sellers (need work done fast)
✓ Average project size: $500-$2,000
✓ Referral fee: $50-$100 per completed job

**What We Get:**
✓ Reliable handyman referral for our sellers
✓ Commission on projects you complete
✓ Better seller experience = more listings

**Typical Scope:**
- Pre-inspection repairs
- Make-ready projects
- Buyer-requested fixes (post-inspection)
- Emergency repairs during listing period

**No Obligation Call?**

Can we chat for 15 minutes about:
- Your interest level
- Capacity for new projects
- Service area coverage
- Referral fee structure

Any day this week works for me.

Best,

Larry Scala
Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. One of our sellers just asked yesterday for handyman referrals. The demand is real.`
  },

  landscaping: {
    subject: "Partnership: Its-Sold.com - Curb Appeal & Yard Work Referrals",
    body: `Hello {CONTACT_NAME},

Larry Scala here from Its-Sold.com™, DFW's FSBO platform.

**The Opportunity:**

Our sellers need landscaping/yard work to boost curb appeal before listing. Currently, they're finding providers through Google, NextDoor, or not at all.

**Why {COMPANY_NAME}:**

We're building a trusted network of service providers. We'd like to feature your landscaping services and send referrals.

**What Sellers Need:**
- Lawn cleanup and maintenance
- Tree/shrub trimming
- Mulch and flower beds
- Sod replacement
- Hardscaping (patios, walkways)
- Full landscape refresh

**Partnership Structure:**

1. **Featured on Seller Resources:** Premium placement for landscaping
2. **Direct Leads:** Contact info sent to you immediately
3. **Referral Commission:** 10-15% of project cost or flat fee per job
4. **Zero Upfront Cost:** Pay only for completed projects

**Typical Projects:**
- Quick curb appeal refresh: $500-$1,500
- Full yard makeover: $2,000-$5,000
- Ongoing maintenance: $150-$300/month
- Hardscaping projects: $5,000-$15,000

**Seller Profile:**
- Motivated to improve home value
- Budget allocated for improvements
- Need work completed within 2-4 weeks
- Potential for maintenance contracts

**15-Minute Discussion?**

Let's talk about:
- Your capacity and service area
- Referral fee structure
- Special packages for FSBO sellers
- Lead volume expectations

Are you free this week?

Thanks,

Larry Scala
Founder, Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. Good landscaping can increase home value by 10-15%. Our sellers understand this and are ready to invest.`
  },

  titleCompanies: {
    subject: "Title Services Partnership: Its-Sold.com FSBO Platform",
    body: `Hello {CONTACT_NAME},

I'm Larry Scala, founder of Its-Sold.com™, connecting with {COMPANY_NAME} about a title services partnership.

**About Us:**

We're DFW's fastest-growing FSBO platform, helping sellers list homes without agent commissions. Every successful listing needs title services.

**The Challenge:**

FSBO sellers don't have agent relationships to navigate title companies. They need:
- FSBO-friendly title companies (some avoid us)
- Guidance through closing process
- Competitive pricing
- Fast turnaround

**Partnership Opportunity:**

We'd like to establish {COMPANY_NAME} as a preferred title provider for Its-Sold.com sellers.

**What This Means:**
✓ Referral fee: 25-40% of title premium (standard in industry)
✓ Steady flow of FSBO closings
✓ Average sale price: $300K-$500K
✓ Sellers pre-qualified and motivated

**What We Provide:**
- Featured placement on our platform
- Direct referrals with full transaction details
- Seller education (we prep them on title process)
- Transaction coordination support

**What You Provide:**
- FSBO-friendly closing services
- Competitive pricing
- Responsive communication with sellers
- Monthly referral fee reporting

**Projected Volume:**
- Current: 5-10 closings/month
- 6-month projection: 20-30 closings/month
- 12-month projection: 40-50 closings/month

**Next Steps:**

I'd like to schedule a call to discuss:
- Your FSBO closing experience
- Referral fee structure
- Service process and timeline
- Co-marketing opportunities

Available for 20 minutes this week?

Best regards,

Larry Scala
Its-Sold.com™ Founder
{YOUR_PHONE}
larry@larryscala.com

P.S. We're also open to exclusive partnerships in specific DFW submarkets if that interests you.`
  },

  attorneys: {
    subject: "Legal Services Partnership: Its-Sold.com FSBO Platform",
    body: `Dear {CONTACT_NAME},

I'm reaching out from Its-Sold.com™ regarding legal services for FSBO transactions.

**The Situation:**

We're connecting DFW FSBO sellers with qualified real estate attorneys. Our sellers need:
- Contract review before signing
- Legal guidance through closing
- Disclosure compliance verification
- Complex transaction support (divorce, estate, etc.)

**Why Partner With Us:**

FSBO sellers often avoid attorneys due to cost concerns, then face legal issues later. We want to change this by:
- Educating sellers on legal importance
- Providing trusted attorney referrals
- Making legal services accessible

**Partnership Structure:**

1. **Featured Attorney Listing:** Profile on our Legal Services section
2. **Direct Referrals:** We send client contact info
3. **Referral Fee:** 10-20% of legal fees or $200-$500 per transaction
4. **No Conflicts:** Only referrals, not representation of our company

**Typical Services Needed:**
- Contract review: $300-$500
- Full transaction representation: $1,000-$2,000
- Complex situations: $2,000-$5,000+
- Post-closing disputes: Varies

**Client Profile:**
- First-time FSBO sellers (need guidance)
- Higher-value homes ($400K-$1M)
- Complex situations (divorce, estate, seller financing)
- Want professional protection without agent costs

**Can We Schedule a Call?**

I'd like to discuss:
- Your experience with FSBO transactions
- Services you offer
- Fee structure and referral arrangement
- Capacity for new clients

Available this week for 20-30 minutes?

Respectfully,

Larry Scala
Its-Sold.com™ Founder
Licensed Real Estate Professional
{YOUR_PHONE}
larry@larryscala.com

P.S. We're also interested in creating FSBO-specific legal packages if that's something you'd consider.`
  },

  homeInspectors: {
    subject: "Inspection Services Partnership: Its-Sold.com FSBO Platform",
    body: `Hello {CONTACT_NAME},

Larry Scala from Its-Sold.com™. I'd like to discuss a home inspection referral partnership.

**About Our Platform:**

We help DFW homeowners sell FSBO. Buyers working with our sellers need pre-purchase inspections, and sellers often need pre-listing inspections.

**Two Revenue Streams:**

1. **Buyer Inspections:** Buyers of FSBO properties (standard inspections)
2. **Seller Pre-Inspections:** Sellers who want to identify issues early

**Partnership Details:**

✓ Featured on Buyer & Seller Resources pages
✓ Direct referrals with contact information
✓ Referral fee: $50-$100 per inspection or 10% of fee
✓ Both buyer and seller-side opportunities

**Why This Works:**

- FSBO buyers often don't have agent referrals
- Sellers want pre-inspections to avoid surprises
- Average home value: $300K-$500K (quality homes)
- Potential for repeat business (buyers become sellers)

**Inspection Types Needed:**
- Standard home inspection: $350-$500
- Pre-listing inspection: $400-$550
- Specialty (foundation, roof, HVAC): $200-$400 each
- New construction: $500-$700

**Projected Volume:**
- Current: 10-15 inspections/month
- 6-month: 30-40 inspections/month
- Mix of buyer and seller-side

**Brief Call This Week?**

Let's discuss:
- Your inspection packages
- Preferred referral structure
- Service area and availability
- Special FSBO seller pricing (optional)

Any day works for me - just 15 minutes.

Thanks,

Larry Scala
Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. We educate sellers on the value of pre-inspections. You'd be surprised how many want them.`
  },

  general: {
    subject: "Service Partnership: Its-Sold.com FSBO Platform - {SERVICE_TYPE}",
    body: `Hello {CONTACT_NAME},

My name is Larry Scala, and I'm the founder of Its-Sold.com™, Dallas-Fort Worth's leading For Sale By Owner platform.

**Why I'm Reaching Out:**

We're building a comprehensive "Seller Resources" directory featuring top DFW service providers. Based on your reputation and reviews, we'd like to feature {COMPANY_NAME} and establish a referral partnership.

**About Its-Sold.com:**
- Free FSBO listing platform serving DFW metroplex
- Growing database of active home sellers
- Average home value: $300K-$500K
- Monthly traffic: 500+ visitors to resources page (growing 20% MoM)

**Partnership Opportunity:**

We'd like to:
1. Feature {COMPANY_NAME} prominently in our {SERVICE_TYPE} section
2. Send qualified referrals directly to you
3. Establish a mutually beneficial referral fee structure
4. Provide performance analytics and reporting

**What You Get:**
✓ Free exposure to motivated FSBO sellers
✓ Qualified leads actively seeking your services
✓ No upfront costs - only pay for closed business
✓ Direct contact information for all referrals
✓ Full control over pricing and scheduling

**No Risk, No Obligation:**
- Zero marketing fees
- Cancel anytime
- You handle client relationships
- We handle lead generation

**Next Steps:**

I'd love to schedule a brief 15-20 minute call to discuss:
- Your current referral programs (if any)
- Optimal referral fee structure
- Service packages for FSBO sellers
- Lead volume expectations
- Tracking and payment processes

Are you available this week for a quick conversation?

Best regards,

Larry Scala
Founder, Its-Sold.com™
Licensed Real Estate Professional
{YOUR_PHONE}
larry@larryscala.com

P.S. We're currently driving consistent traffic to our resources page, and FSBO sellers are actively seeking trusted service providers. This is a win-win opportunity.`
  }
};

// Helper function to personalize templates
export const personalizeEmail = (template, data) => {
  let email = { ...template };
  
  // Replace placeholders
  email.subject = email.subject
    .replace('{COMPANY_NAME}', data.companyName || '[Company Name]')
    .replace('{SERVICE_TYPE}', data.serviceType || '[Service Type]');
    
  email.body = email.body
    .replace(/{CONTACT_NAME}/g, data.contactName || '[Contact Name]')
    .replace(/{COMPANY_NAME}/g, data.companyName || '[Company Name]')
    .replace(/{YOUR_PHONE}/g, data.yourPhone || '(817) 320-5334')
    .replace(/{YOUR_EMAIL}/g, data.yourEmail || 'larry@larryscala.com')
    .replace(/{SERVICE_TYPE}/g, data.serviceType || '[Service Type]');
    
  return email;
};

// Follow-up email template
export const followUpTemplate = {
  subject: "Following Up: Its-Sold.com Partnership Opportunity",
  body: `Hi {CONTACT_NAME},

I wanted to follow up on my email from last week regarding a referral partnership between {COMPANY_NAME} and Its-Sold.com™.

I understand you're busy, so I'll keep this brief:

**Quick Recap:**
- We're DFW's leading FSBO platform
- We want to refer {SERVICE_TYPE} leads to you
- No upfront costs - referral fee on closed business only
- Currently driving 500+ monthly visitors

**One Simple Question:**

Is this something you'd be interested in exploring? If so, I can send over:
- More details about our platform
- Projected lead volume
- Sample referral agreement
- Case studies from other partners

If not interested, just let me know and I won't bother you again.

Either way, I appreciate your time.

Best,

Larry Scala
Its-Sold.com™
{YOUR_PHONE}
larry@larryscala.com

P.S. If timing isn't right now, I'm happy to reconnect in 3-6 months when you have more capacity.`
};
